// Mock Supabase client for frontend development
export const supabase = {
  auth: {
    onAuthStateChange: () => {
      return {
        data: { subscription: { unsubscribe: () => {} } }
      };
    },
    getSession: async () => ({
      data: { session: null },
      error: null
    }),
    getUser: async () => ({
      data: { user: null },
      error: null
    })
  },
  from: () => ({
    select: () => ({
      eq: () => ({
        single: async () => ({ data: null, error: null })
      })
    }),
    insert: () => ({
      select: () => ({
        single: async () => ({ data: null, error: null })
      })
    }),
    update: () => ({
      eq: () => ({
        single: async () => ({ data: null, error: null })
      })
    })
  })
};

// Health check function
export async function checkSupabaseConnection() {
  return true;
}